import * as React from 'react';

export default function textMedium({ templateSection }) {
  const text = templateSection && templateSection.text ? templateSection.text : 'Introduction Copy';

  return <p className="pdf-subtitle">{text}</p>;
}
